import { Typography, Checkbox } from "@mui/material";
import { useRecoilState } from "recoil";
import type { ChangeEvent } from "react";
import {
  AlertTitleWrapper,
  OptionLabel,
  PatientInfoAlert,
  ProviderAuthCheckboxLabel,
  SectionTitleText,
  StyledRedSpan,
} from "./NewRequisition.styles";
import { currentNewRequisitionEdit } from "../../recoil/atoms";
import { flushCheckboxSx } from "./testPanelStyles";

const ClinicalIndicationAlert = () => {
  const [newRequisition, setNewRequisition] = useRecoilState(
    currentNewRequisitionEdit,
  );
  const { requisitionForm } = newRequisition;

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setNewRequisition((current) => ({
      ...current,
      requisitionForm: {
        ...current.requisitionForm,
        [name]: checked,
      },
    }));
  };

  return (
    <PatientInfoAlert
      icon={false}
      $isError={!requisitionForm.providerAuthorization}
    >
      <AlertTitleWrapper>
        <Typography variant="h6">
          <SectionTitleText>
            Provider authorization
            <StyledRedSpan>*</StyledRedSpan>
          </SectionTitleText>
        </Typography>
      </AlertTitleWrapper>
      <OptionLabel $tone="muted">
        By submission of this requisition and accompanying sample, I hereby
        authorize and direct BillionToOne to (1) utilize the above information
        to process the indicated test for this patient and (2) release the
        results and patient information to the patient&apos;s third-party payer,
        as needed. I certify (1) all information provided herein is true and
        accurate, (2) I am authorized by law to request the test, (3) the test
        is reasonable and medically necessary for the treatment and management
        of this patient, (4) the patient has been counseled on the potential
        results, benefits and limitations of the test, and (5) I have obtained
        informed consent to the extent required under applicable law. I agree to
        provide the necessary information and medical records to BillionToOne
        needed to submit and process claims to payers.
      </OptionLabel>

      <ProviderAuthCheckboxLabel
        control={
          <Checkbox
            id="new-test-provider-auth"
            sx={flushCheckboxSx}
            checked={requisitionForm.providerAuthorization}
            name="providerAuthorization"
            onChange={onChange}
          />
        }
        label={
          <OptionLabel $tone="muted">
            {`Signed and submitted by ordering provider: ${requisitionForm.orderingHealthcareProviderFormatted}`}
          </OptionLabel>
        }
      />
    </PatientInfoAlert>
  );
};
export default ClinicalIndicationAlert;
